import styled from 'styled-components';
import { Row } from 'antd';

export const ContainerRow = styled(Row)`
  margin-bottom: 16px;

  .ant-statistic-content {
    overflow: hidden;
  }

  .ant-badge {
    height: 100%;
    .ant-badge-status-dot {
      width: 14px;
      height: 14px;
    }
  }
`;
